import { get } from 'lodash';

export const buildSiteNameWithNumber = (siteInfo: {
  site_name: string;
  store_number: string;
}): string => {
  return `${get(siteInfo, 'site_name', '')} [${get(siteInfo, 'store_number', '')}]`;
};
